import { Mutation, MutationTree } from 'vuex'
import { State } from './state'
import  { AuthenticationError } from '@/services/responses/AuthenticationError';


export function loginRequest(state: State) {
    state.authenticating = true;
    state.authenticationError = new AuthenticationError('', 0);

}

export function loginSuccess(state: State, accessToken:string|null) {
    state.accessToken = accessToken
    state.authenticating = false;
    state.authenticationError = new AuthenticationError('', 0);
}

export function loginError(state: State, authenticationError: AuthenticationError) {
    state.authenticating = false;
    state.authenticationError = authenticationError;
}

export function logoutSuccess(state: State) {
    state.accessToken = '';
    state.authenticating = false;
    state.authenticationError = new AuthenticationError('', 0);
}


export default <MutationTree<State>> {
    loginRequest, loginSuccess, loginError, logoutSuccess
}
